<div class="press-inquiries-area ptb-80">
  <div class="container">
    <div class="section-title">
      <h3 i18n="@@pressRoomInquiriesTitle">Press inquiries</h3>
      <div class="bar"></div>
    </div>
    <div class="row">
      <div class="d-flex">
        <h4 i18n="@@pressRoomInquiriesContactUs">
          Contact us for press inquiries at <a href="mailto:press@wipperoz.com">press@wipperoz.com</a>
        </h4>
      </div>
    </div>
  </div>
</div>
